import { render, staticRenderFns } from "./courseFooter.vue?vue&type=template&id=080c5fa3&scoped=true"
import script from "./courseFooter.vue?vue&type=script&lang=js"
export * from "./courseFooter.vue?vue&type=script&lang=js"
import style0 from "./courseFooter.vue?vue&type=style&index=0&id=080c5fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c5fa3",
  null
  
)

export default component.exports